'use client';

import { forwardRef } from 'react';
import type { GroupProps as MantineGroupProps, PolymorphicComponentProps } from '@mantine/core';
import { Group as MantineGroup } from '@mantine/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type GroupProps = PolymorphicComponentProps<any, MantineGroupProps>;

export const Group = forwardRef<HTMLDivElement, GroupProps>((props, ref) => {
  return <MantineGroup {...props} ref={ref} />;
});

Group.displayName = 'Group';
